import { Box, keyframes, Palette, Typography } from "@mui/material";

interface ILoadingBlockProps {
  palette: Palette;
  translate: (text: string, options?: any) => string;
}

const dotBlink = keyframes`
  0%, 20% { opacity: 0; }
  50% { opacity: 1; }
  100% { opacity: 0; }
`;

const AnimatedDots = ({ palette }: { palette: Palette }) => (
  <Box component="span" sx={{ display: "inline-flex", gap: "2px", ml: 1 }}>
    <Box
      component="span"
      sx={{
        width: "4px",
        height: "4px",
        borderRadius: "50%",
        backgroundColor: palette.text.label,
        animation: `${dotBlink} 1.4s ease-in-out infinite`,
        animationDelay: "0s",
      }}
    />
    <Box
      component="span"
      sx={{
        width: "4px",
        height: "4px",
        borderRadius: "50%",
        backgroundColor: palette.text.label,
        animation: `${dotBlink} 1.4s ease-in-out infinite`,
        animationDelay: "0.2s",
      }}
    />
    <Box
      component="span"
      sx={{
        width: "4px",
        height: "4px",
        borderRadius: "50%",
        backgroundColor: palette.text.label,
        animation: `${dotBlink} 1.4s ease-in-out infinite`,
        animationDelay: "0.4s",
      }}
    />
  </Box>
);

const LoadingBlock: React.FC<ILoadingBlockProps> = ({ palette, translate }) => {
  return (
    <Box
      sx={{
        p: 1.5,
        mb: 1,
      }}
    >
      <Typography
        variant="body2"
        sx={{
          color: palette.text.label,
          display: "flex",
          alignItems: "center",
        }}
      >
        {translate("processing")}
        <AnimatedDots palette={palette} />
      </Typography>
    </Box>
  );
};

export { AnimatedDots, LoadingBlock };
